module.exports = __webpack_public_path__ + "img/worldmap_lamp_pic.9eb358d4.png";